@if (!showSpinner$$() || _hasRows$$()) {
    @if (!deletedListShow$$()) {
        <!-- Geen virtual scroll: korte lijsten, rijen mogen in hoogte variëren (open paneel). -->
        <div #scrollContainer class="viewport expansion-viewport" (scrollend)="emit_onScrollEnd()" [style.--shape-list-item-size.px]="itemSize$$()" @show>
            <div class="viewport-padding">
                <!-- Slepen (sortable): cdkDropList op de lijst, cdkDrag per rij; neerzetten alleen binnen de eigen groep. -->
                <mat-nav-list class="expansion-list" role="list"
                    cdkDropList
                    [cdkDropListData]="listFiltered$$()"
                    [cdkDropListDisabled]="!dragEnabled$$()"
                    [cdkDropListSortPredicate]="sortPredicate"
                    (cdkDropListDropped)="emit_onDrop($event)"
                >
                    @for (item of listFiltered$$(); track item.guid; let i = $index) {
                        @let __expandable = isExpandable(item);
                        @let __expanded = __expandable && isExpanded(item);
                        @let __draggable = isDraggable(item);
                        <div class="expansion-row" [class.expansion-row--expanded]="__expanded" [class.expansion-row--draggable]="__draggable" role="listitem"
                            cdkDrag
                            cdkDragLockAxis="y"
                            [cdkDragData]="item"
                            [cdkDragDisabled]="!__draggable"
                            [cdkDragStartDelay]="dragStartDelay"
                        >
                            @if (i >= 1 && !__expanded) {
                                <mat-divider />
                            }
                            <div class="expansion-row__header" [class.expansion-row__header--toggle]="__expandable">
                                <!-- Klik op de rij = doorklikken (zoals elke lijst), of met rowToggles het paneel
                                     open/dicht; de uitklapknop staat ernaast. -->
                                <a mat-list-item class="expansion-row__main"
                                    (click)="emit_row_click($event, item)"
                                    [activated]="isActivated(item)"
                                    [attr.aria-controls]="input_rowToggles$$() && __expandable ? panelId(item) : null"
                                    [attr.aria-expanded]="input_rowToggles$$() && __expandable ? __expanded : null"
                                    [class.no-click-through]="!input_rowToggles$$() && !canClickThrough$$()"
                                    [class.list-item--inactive]="_rowInactive(item)"
                                    [lines]="1"
                                >
                                    <ng-container *ngTemplateOutlet="template$$(); context: {$implicit: item}"></ng-container>
                                </a>
                                @if (__expandable) {
                                    <button type="button" class="expansion-row__toggle"
                                        (click)="toggleExpanded(item)"
                                        [attr.aria-controls]="panelId(item)"
                                        [attr.aria-expanded]="__expanded"
                                        [attr.aria-label]="__expanded ? _toggleLabel.collapse : _toggleLabel.expand"
                                    >
                                        @if (toggleText(item); as __text) {
                                            <span class="expansion-row__toggle-text">{{ __text }}</span>
                                        }
                                        <app-icon class="expansion-row__chevron" [class.expansion-row__chevron--open]="__expanded" name="caret-down" />
                                    </button>
                                }
                            </div>
                            @if (__expanded) {
                                <div class="expansion-row__panel" role="region" [id]="panelId(item)" [@expandPanel]="expandPanel$$()">
                                    <ng-container *ngTemplateOutlet="input_panelTemplate$$(); context: {$implicit: item}"></ng-container>
                                </div>
                            }
                        </div>
                    }
                </mat-nav-list>
            </div>
        </div>
    }
    @else {
        <!-- Verwijderd-/inactief-lijst: gewone selectielijst (herstellen), geen panelen. -->
        <div #scrollContainer class="viewport expansion-viewport" (scrollend)="emit_onScrollEnd()" [style.--shape-list-item-size.px]="itemSize$$()" @show>
            <div class="viewport-padding">
                <mat-selection-list #matList
                    (selectionChange)="emit_change($event)"
                >
                    @for (listItem of listFiltered$$(); track listItem.guid; let i = $index) {
                        <mat-list-option
                            [value]="listItem"
                            [selected]="!listItem?.deleted"
                        >
                            @if (i >= 1) {
                                <mat-divider />
                            }
                            <ng-container *ngTemplateOutlet="template$$(); context: {$implicit: listItem}"></ng-container>
                        </mat-list-option>
                    }
                </mat-selection-list>
            </div>
        </div>
    }
    <app-list-position [scrollElement]="scrollElement$$()" [list]="listFiltered$$()" />
}
@if (showSpinner$$()) {
    <div class="loading-overlay" [class.loading-overlay--over]="_hasRows$$()"><div class="spinner"></div></div>
}

<ng-template #template_footer>
    <app-tablist-footer
        (onFilterChange)="emit_onFilterChange()"
    ></app-tablist-footer>
</ng-template>

<ng-template #template_buttons>
    @if (!loadingPage$$() && !buttonsHide$$()) {
        @if (mainListShow$$()) {
            <div class="button-row" [@showHide]>
                @if (btnAddShow$$()) {
                    <app-button-action
                        (btnClick)="emit_btnAdd_click()"
                        [tooltip]="'add to list'"
                    >
                        <app-icon name="plus" />
                    </app-button-action>
                }
                @if (btnDeletedListShow$$() && hasDeletedList$$()) {
                    <app-button-action
                        (btnClick)="emit_toggleDeleted()"
                        [tooltip]="'deleted from list'"
                    >
                        <app-icon name="deleted-list" />
                    </app-button-action>
                }
                @if (btnDeletedListShow$$() && hasInactiveList$$()) {
                    <app-button-action
                        (btnClick)="emit_toggleDeleted(_tabModeInactive)"
                        [tooltip]="'inactive list'"
                    >
                        inactive
                    </app-button-action>
                }
            </div>
        } @else {
            <div class="button-row" [@showHide]>
                <app-button-action
                    (btnClick)="emit_toggleDeleted()"
                    [tooltip]="'cancel'"
                >
                    <app-icon name="xmark" />
                </app-button-action>
                @if (deletedListShow$$() && btnRestoreListShow$$() && !input_restoreHide$$()) {
                    <app-button-action
                        (btnClick)="emit_btnRestore_click()"
                        [tooltip]="'restore selection'"
                        [disabled]="btnRestoreDisabled$$()"
                    >
                        restore
                    </app-button-action>
                }
                @if (deletedListShow$$() && btnDeleteDeepShow$$()) {
                    <app-button-action
                        (btnClick)="emit_btnDeleteDeep_click()"
                        [tooltip]="'delete selection permanently'"
                        [disabled]="btnDeleteDeepDisabled$$()"
                    >
                        delete
                    </app-button-action>
                }
                @if (inactiveListShow$$() && !input_restoreHide$$()) {
                    <app-button-action
                        (btnClick)="emit_btnRestore_click()"
                        [tooltip]="'restore selection'"
                        [disabled]="btnRestoreDisabled$$()"
                    >
                        restore
                    </app-button-action>
                }
            </div>
        }
    }
</ng-template>
